export default {
    metaTitleBrand: "LOYA SPORT",
    metaTitleHome: "Home",
    metaTitleProducts: "Products",
    metaTitleProductDetail: "Product Detail",
    metaTitleCustomService: "Custom Service",
    metaTitleSolutions: "Solutions",
    metaTitleAbout: "About Us",
    metaTitleContact: "Contact Us",
    metaTitleBlog: "Blog",
    metaTitleLogin: "Login",
    metaTitleAdmin: "Admin Dashboard",
    metaTitleSystemSetup: "System Setup",
    contactDocsTitle: "Documents Available",
    contactDocsDesc: "Commercial invoice, packing list, and shipping coordination support.",
    contactSampleTitle: "Sampling Service",
    contactSampleDesc: "Rapid sample arrangement for OEM and private-label projects.",
    searchOverlayPlaceholder: "Search products by name...",
    searchOverlaySubmitAria: "Submit search",
    searchOverlaySubmitTitle: "Search",
    searchOverlayHintPrefix: "Press",
    searchOverlayHintSuffix: "to view all matching products, or pick a quick result below.",
    searchOverlayCloseAria: "Close search",
    searchOverlayQuickResults: "Quick Results",
    searchOverlayQuickResultsAria: "Quick search results",
    searchOverlayFallbackCategory: "Yoga Accessories",
    searchOverlayHistory: "Search History",
    searchOverlayClear: "Clear",
    searchOverlayNoHistory: "No recent searches",
    searchOverlayRecommended: "Recommended Keywords",
    searchOverlayFallbackKeyword: "Yoga Mat",
    blogHeroKicker: "Content Center",
    blogHeroTitle: "Insights & Buying Guides",
    blogSearchAria: "Search articles",
    blogReadingTimeMin: "min read",
    blogShowLess: "Show less",
    blogCategoryAria: "Article categories",
    blogFeaturedPlaceholder: "Featured Insight",
    blogPaginationAria: "Blog pagination",
    blogCtaAria: "Blog call to action",
    requestFreeSample: "Request Free Sample",
    factoryStatsSince: "Exporting Since 2008",
    factoryStatsCapacity: "10,000+ Units Monthly",
    factoryStatsExport: "Serving 50+ Countries",
    factoryStatsCert: "ISO 9001 & BSCI Certified",
    aboutHeroTitle: "Young, Professional, Focused — Your Experts in Yoga Supply Chain Integration",
    aboutHeroBody: "LOYA SPORT, located in Changsha, Hunan, China, boasts a vibrant and professional team. We are dedicated to providing overseas buyers with meticulously selected yoga supply chain integration services, covering the entire process from source factory screening to in-depth custom development.",
    aboutAddress: "Address: Ruihe Kechuang Building, Wanglong Road, Yuelu District, Changsha, Hunan, China",
    aboutTeamTitle: "Vibrant & Professional Team",
    aboutTeamBody: "We are young yet experienced, with a deep understanding of market demands and technical details in the yoga industry. Through rigorous selection logic and efficient response speeds, we ensure every delivered product meets high commercial expectations.",
    aboutCustomizationTitle: "Comprehensive Customization Services",
    aboutCustomizationBody: "From logo printing and packaging design to product function mold development, we provide flexible and in-depth customization solutions to help your brand stand out in the market.",
    aboutFactoryPartnerTitle: "Premium Factory Partners",
    aboutFactoryPartnerBody: "We work closely with ISO/BSCI-certified manufacturing bases, controlling quality from the source to ensure production stability and on-time delivery.",
    aboutHeroKicker: "Supply Chain Integrator",
    aboutMetric1: "single project window for product, packaging, and delivery communication",
    aboutMetric2: "factory resources coordinated under one sourcing and follow-up structure",
    aboutMetric3: "workflow built for importers, retailers, distributors, and private label buyers",
    aboutPlaceholderNote: "Our role is to reduce fragmented communication between buyer, supplier, and factory execution teams, so projects move with more clarity and fewer blind spots.",
    aboutHeroImageAlt: "Supply chain coordination meeting for export buyers",
    aboutHeroCaption: "From inquiry to shipment, we coordinate the details that usually get split across sourcing agents, factories, and logistics contacts.",
    aboutOfficeImageAlt: "Changsha Loya Technology office building",
    aboutOfficeCaption: "Changsha Loya Technology Office",
    aboutTeamImageAlt: "Our professional team in Changsha office",
    aboutFactoryImageAlt: "Yoga mat production line and quality workflow",
    aboutFactoryCollageAlt: "Factory warehouse and production details",
    aboutWhatWeDoTitle: "What We Actually Do",
    aboutWhatWeDoBody1: "Many buyers do not need just a catalog. They need a partner who can connect commercial requirements with actual factory execution. That is where we work. We coordinate supplier selection, pricing discussion, product sampling, packaging execution, production follow-up, inspection alignment, and export readiness.",
    aboutWhatWeDoBody2: "Instead of leaving product details, packaging files, delivery timing, and order changes with separate contacts, we centralize the process and keep the project moving through one accountable communication path.",
    aboutBadge1: "Supplier Matching",
    aboutBadge2: "Sample Follow-up",
    aboutBadge3: "Packaging Execution",
    aboutBadge4: "Shipment Readiness",
    aboutSideImageAlt: "Buyer communication and project review",
    aboutIntegratedCapabilitiesTitle: "Integrated Supply Capabilities",
    aboutSideCaption: "We focus on making the sourcing chain easier to manage for overseas buyers who need dependable coordination more than isolated trading activity.",
    aboutCapabilityCard1Title: "Supplier Network Integration",
    aboutCapabilityCard1Body: "We combine factory resources, category knowledge, and sourcing controls into one buyer-facing workflow so you do not need to coordinate multiple parties by yourself.",
    aboutCapabilityCard2Title: "Commercial & Technical Coordination",
    aboutCapabilityCard2Body: "From quotation, sampling, and packaging details to spec confirmation and production checkpoints, we keep the commercial side and factory side aligned.",
    aboutCapabilityCard3Title: "Execution for Export Orders",
    aboutCapabilityCard3Body: "We follow orders through inspection, documentation, booking, and shipment readiness to reduce communication gaps and delivery risk.",
    aboutOperatingModel1: "Category sourcing and factory matching based on your target market and price position.",
    aboutOperatingModel2: "Sampling, spec review, and packaging coordination before production is locked.",
    aboutOperatingModel3: "Production follow-up, quality checkpoints, and shipment preparation under one project flow.",
    aboutOperatingModel4: "Single communication window for product, packaging, documentation, and delivery progress.",
    aboutWhoWeServeTitle: "Who We Serve",
    aboutBuyerScenario1Title: "For Importers & Distributors",
    aboutBuyerScenario1Body: "We help consolidate product lines, compare supplier options, and build a more stable replenishment plan across categories.",
    aboutBuyerScenario2Title: "For Retail Chains & E-commerce Sellers",
    aboutBuyerScenario2Body: "We support launch-ready assortments, private label packaging, and practical communication for repeatable orders.",
    aboutBuyerScenario3Title: "For Brands Expanding Product Lines",
    aboutBuyerScenario3Body: "We act as the coordination layer between your concept, the production side, and export execution so internal teams move faster.",
    aboutWorkflowTitle: "How Our Workflow Is Structured",
    aboutWorkflowStep1: "Requirement intake and target product clarification",
    aboutWorkflowStep2: "Supplier matching, quotation, and sample planning",
    aboutWorkflowStep3: "Specification, packaging, and compliance review",
    aboutWorkflowStep4: "Production follow-up, inspection, and shipment readiness",
    aboutWhyIntegratorTitle: "Why Buyers Use a Supply Chain Integrator",
    aboutWhyIntegratorBody1: "When sourcing crosses multiple suppliers, packaging vendors, and shipment timelines, the biggest risk is usually not the first quotation. It is the loss of alignment after the order starts moving.",
    aboutWhyIntegratorList1: "Specifications can drift between quotation and production.",
    aboutWhyIntegratorList2: "Packaging and branding details can be delayed by fragmented communication.",
    aboutWhyIntegratorList3: "Inspection, paperwork, and shipment preparation can become disconnected from the original commercial promise.",
    aboutWhyIntegratorBody2: "Our value is to keep those parts connected. We work as a coordination layer between buyer expectations and supplier execution so decisions are documented, timing is followed up, and handoff risk is reduced.",
    aboutTalkToTeam: "Talk to Our Team",
    aboutPositioningTitle: "Our Positioning",
    aboutPositioningBody: "LOYA SPORT positions itself as a supply chain integrator for export-oriented fitness products. We help customers buy with clearer coordination, stronger supplier organization, and a more manageable path from sourcing to shipment.",
    solutionsHeroKicker: "Solutions",
    solutionsHeroTitle: "Choose the right sourcing route for your buyer type",
    solutionsHeroBody: "Built as a visual guide for channel fit, scenario fit and product-program planning.",
    solutionsTalkToSales: "Talk to Sales",
    solutionsBrowseProducts: "Browse Products",
    solutionsHeroImageAlt: "B2B sourcing solutions for yoga and light fitness buyers",
    solutionsHeroBadgeTitle: "Solution fit",
    solutionsHeroBadgeBody: "Buyer type + use case + assortment",
    solutionsBuyerTypeTitle: "Buyer-Type Solutions",
    solutionsViewMatchingProducts: "View Matching Products",
    solutionsScenarioPlansTitle: "Scenario Plans",
    solutionsProgramMixesTitle: "Recommended Program Mixes",
    solutionsNextStepKicker: "Next Step",
    solutionsNextStepTitle: "Need a tailored mix for your market?",
    solutionsNextStepBody: "Share your buyer type, target products and destination market. We will suggest a practical assortment route.",
    solutionsRequestPlan: "Request a Solution Plan",
    solutionsExploreOem: "Explore OEM Support",
    solutionsBuyerCard1Title: "Wholesalers",
    solutionsBuyerCard1Subtitle: "Fast assortment building for bulk programs.",
    solutionsBuyerCard1Need1: "Need stable bulk supply with fewer stock-out risks",
    solutionsBuyerCard1Need2: "Need carton-ready SKU mixes to speed up resale",
    solutionsBuyerCard1Need3: "Need repeat reorder cycles with predictable lead time",
    solutionsBuyerCard1Tag1: "Bulk assortments",
    solutionsBuyerCard1Tag2: "Carton-ready packs",
    solutionsBuyerCard1Tag3: "Repeat restocking",
    solutionsBuyerCard2Title: "Retailers",
    solutionsBuyerCard2Subtitle: "Shelf-ready packs and steady replenishment.",
    solutionsBuyerCard2Need1: "Need clear price ladders from entry to premium",
    solutionsBuyerCard2Need2: "Need barcode-ready packaging for faster shelf listing",
    solutionsBuyerCard2Need3: "Need reliable replenishment for fast-moving items",
    solutionsBuyerCard2Tag1: "Retail packs",
    solutionsBuyerCard2Tag2: "Barcode support",
    solutionsBuyerCard2Tag3: "Display-friendly mixes",
    solutionsBuyerCard3Title: "Fitness Brands",
    solutionsBuyerCard3Subtitle: "Private label programs for brand expansion.",
    solutionsBuyerCard3Need1: "Need custom branding without rebuilding the full supply chain",
    solutionsBuyerCard3Need2: "Need packaging styles that match brand positioning",
    solutionsBuyerCard3Need3: "Need faster sample-to-launch timelines",
    solutionsBuyerCard3Tag1: "Logo application",
    solutionsBuyerCard3Tag2: "Custom packaging",
    solutionsBuyerCard3Tag3: "Brand line extension",
    solutionsBuyerCard4Title: "Yoga Studios",
    solutionsBuyerCard4Subtitle: "Studio kits, props and class bundles.",
    solutionsBuyerCard4Need1: "Need starter kits for new members and trial classes",
    solutionsBuyerCard4Need2: "Need durable props suitable for high-frequency sessions",
    solutionsBuyerCard4Need3: "Need practical bundle pricing for upsell programs",
    solutionsBuyerCard4Tag1: "Starter sets",
    solutionsBuyerCard4Tag2: "Class props",
    solutionsBuyerCard4Tag3: "Member upgrade kits",
    solutionsBuyerCard5Title: "Amazon Sellers",
    solutionsBuyerCard5Subtitle: "Marketplace-ready bundles and packaging.",
    solutionsBuyerCard5Need1: "Need compact bundle structure to control shipping cost",
    solutionsBuyerCard5Need2: "Need listing-friendly product combinations for conversion",
    solutionsBuyerCard5Need3: "Need packaging quality that reduces return rate",
    solutionsBuyerCard5Tag1: "Compact bundles",
    solutionsBuyerCard5Tag2: "Image-ready packaging",
    solutionsBuyerCard5Tag3: "Low-friction launches",
    solutionsBuyerCard6Title: "E-commerce Businesses",
    solutionsBuyerCard6Subtitle: "Visual-first products for repeat online sales.",
    solutionsBuyerCard6Need1: "Need hero SKUs that perform in ads and social traffic",
    solutionsBuyerCard6Need2: "Need flexible bundles to lift AOV",
    solutionsBuyerCard6Need3: "Need quick catalog refresh for seasonal campaigns",
    solutionsBuyerCard6Tag1: "Hero products",
    solutionsBuyerCard6Tag2: "Bundle logic",
    solutionsBuyerCard6Tag3: "Fast catalog refresh",
    solutionsScenario1Title: "Studio Starter Sets",
    solutionsScenario1Body: "Launch-ready yoga bundles for classes, trials and membership packs.",
    solutionsScenario2Title: "Recovery & Massage Zones",
    solutionsScenario2Body: "Massage tools, rollers and recovery accessories for gym corners.",
    solutionsScenario3Title: "Retail Display Programs",
    solutionsScenario3Body: "Balanced assortments with packaging suited for shelf presentation.",
    solutionsScenario4Title: "Online Bundle Offers",
    solutionsScenario4Body: "Compact kits designed for conversion-focused product pages.",
    solutionsProgram1Title: "Studio Launch Mix",
    solutionsProgram1Body: "A clean starter assortment for class-based yoga businesses.",
    solutionsProgram1Item1: "Yoga mats",
    solutionsProgram1Item2: "Blocks & straps",
    solutionsProgram1Item3: "Massage accessories",
    solutionsProgram1SuitedFor: "Studios / trainers",
    solutionsProgram2Title: "Retail Shelf Program",
    solutionsProgram2Body: "Balanced product family for stores needing clear price ladders and repeat orders.",
    solutionsProgram2Item1: "Core mats",
    solutionsProgram2Item2: "Pilates props",
    solutionsProgram2Item3: "Impulse recovery tools",
    solutionsProgram2SuitedFor: "Retailers / distributors",
    solutionsProgram3Title: "Online Bundle Pack",
    solutionsProgram3Body: "Compact product sets built for PDP visuals and easier online conversion.",
    solutionsProgram3Item1: "Mini kits",
    solutionsProgram3Item2: "Giftable packs",
    solutionsProgram3Item3: "Private label inserts",
    solutionsProgram3SuitedFor: "Amazon / e-commerce",
    contactResponseTitle: "Average Response Time",
    contactResponseDesc: "Within 8 business hours for standard RFQ requests.",
    carouselLoadingTitle: "Loading banner images",
    carouselLoadingBody: "We are preparing the homepage visuals for you. Please wait a moment while banner images are loaded.",
    carouselPlaceholderTitle: "Banner images are being prepared",
    carouselPlaceholderBody: "The homepage carousel will appear here once image resources are ready.",
    aboutProductDev: "Product Development",
    aboutProductDevDesc: "Rapid sample cycles and practical design collaboration for faster market launch.",
    aboutSupplyReliability: "Supply Reliability",
    aboutSupplyReliabilityDesc: "Stable material sourcing and capacity planning to keep deliveries on track across peak seasons.",
    aboutTradeSupport: "Delivery & After-Sales Support",
    aboutTradeSupportDesc: "Documentation, shipping coordination, and post-sales support for smoother international operations.",
    aboutSupplyList1: "Verified supplier coordination for yoga and light fitness lines",
    aboutSupplyList2: "Multi-stage quality review with partner factories",
    aboutSupplyList3: "Private label and packaging support",
    aboutSupplyList4: "Global supply support across major regions and channels",
    oemCapability1: "Custom logo printing, embossing and laser marking for core yoga accessories.",
    oemCapability2: "Color, material, texture and size adjustments aligned to your target market.",
    oemCapability3: "Retail-ready packaging, insert cards, barcode labels and carton marks.",
    oemCapability4: "Bundle development for studio sets, Amazon-ready packs and seasonal promos.",
    oemProcess1Title: "Share your idea",
    oemProcess1Body: "Send target products, logo files, reference images, packaging expectations and estimated quantity.",
    oemProcess2Title: "Confirm specs and MOQ",
    oemProcess2Body: "We review material options, branding method, compliance points, lead time and the workable starting quantity.",
    oemProcess3Title: "Sampling and revision",
    oemProcess3Body: "We arrange samples or mockups, collect your feedback and lock the production standard before deposit.",
    oemProcess4Title: "Mass production and inspection",
    oemProcess4Body: "Production follows the approved sample, with packaging checks and pre-shipment quality review.",
    news1Title: "Spring sourcing guide released",
    news1Body: "Explore the latest yoga, pilates and recovery product trends for the upcoming retail season.",
    news2Title: "OEM packaging updates",
    news2Body: "We now support more eco-friendly carton, insert card and barcode packaging options for private-label programs.",
    news3Title: "Export schedule notice",
    news3Body: "Lead-time planning and shipping windows are updated weekly to help buyers manage launch calendars more accurately.",
    navYogaMats: "Yoga Mats",
    navYogaBlocks: "Yoga Blocks",
    navYogaStraps: "Yoga Straps",
    navResistanceBands: "Resistance Bands",
    navPilatesRings: "Pilates Rings",
    navFoamRollers: "Foam Rollers",
    navOemPrivateLabel: "Custom Service",
    navSolutionsControl: "Solutions",
    navBlog: "Blog",
    navCompanyProfile: "About",
    navContactUs: "Contact Us",
    seeAllCategories: "See all categories", productDetailReady: "Private Label Ready",
    productDetailQuote: "Quote on request",
    productDetailViewSpecs: "View Specs",
    productDetailRequestQuote: "Request Quote",
    pdLoadErrorProductDetail: "Failed to load product detail",
    pdLoadErrorRelatedProducts: "Failed to load related products",
    pdLoadErrorStorefrontConfig: "Failed to load storefront config",
    pdLoading: "Loading product detail...",
    pdSampleDefaultMessage: "Please share sample policy, lead time and quotation details.",
    pdAttrProductName: "Product name",
    pdAttrModelNo: "Model No.",
    pdAttrCategory: "Category",
    pdAttrManufacturer: "Manufacturer",
    pdLeadTimeOnRequest: "Lead time on request",
    pdLeadTimeUpTo: "Up to {qty} pcs: {days} days",
    pdLeadTimeFrom: "{qty}+ pcs: {days} days",
    pdLeadTimeDaysOnly: "{days} days",
    pdContactForQuote: "Contact for quote",
    pdPerPiece: "{price} / piece",
    pdAnonymousBuyer: "Anonymous buyer",
    pdReviewTipSignIn: "Please sign in as customer to vote helpful.",
    pdReviewTipSessionExpired: "Session expired. Please sign in again to vote.",
    pdReviewTipNoPermission: "Current account cannot vote helpful.",
    pdReviewTipUpdateFailed: "Failed to update helpful state",
    pdSpecValues: "Values",
    pdSpecRequired: "Required",
    pdSpecOptional: "Optional",
    pdCapabilityCustomLogo: "Custom logo application",
    pdCapabilitySampleDev: "Sample-based development",
    pdCapabilityPackagingCoordination: "Packaging coordination",
    pdCapabilityExportFollowUp: "Export shipment follow-up",
    pdPackagingSellingUnit: "Selling unit",
    pdPackagingSingleItem: "Single item",
    pdPackagingType: "Packaging",
    pdPackagingTypeFallback: "OPP bag / export carton",
    pdPackagingLoadingAdvice: "Loading advice",
    pdPackagingLoadingAdviceFallback: "Based on order structure",
    pdPackagingLeadTime: "Lead time",
    pdMediaPhotoLabel: "Photo {index}",
    pdMediaVideoLabel: "Video",
    pdMediaAttributesLabel: "Attributes",
    pdPackagingPointPackaging: "Packaging: {value}",
    pdPackagingPointLoadingAdvice: "Loading advice: {value}",
    pdPackagingPointShippingPort: "Shipping port: {value} (negotiable)",
    pdPackagingPointShippingPortNegotiable: "Shipping port: negotiable",
    pdPackagingPointLeadTime: "Lead time: {value}",
    pdInquiryHello: "Hello, I want to inquire about:",
    pdInquiryProduct: "Product: {value}",
    pdInquirySku: "SKU: {value}",
    pdInquirySkuName: "SKU Name: {value}",
    pdInquiryModel: "Model: {value}",
    pdInquiryQuantity: "Quantity: {value}",
    pdEmailSubject: "Inquiry: {sku} - {name}",
    pdInquirySubmitFailed: "Unable to submit inquiry right now.",
    pdSampleContactPerson: "Contact person: {value}",
    pdSampleWhatsapp: "WhatsApp/WeChat: {value}",
    pdSampleCompany: "Company: {value}",
    pdSampleRequestedQuantity: "Requested quantity: {value}",
    pdSampleSelectorQuantity: "Page quantity selector: {value}",
    pdVariationLabel: "Option",
    pdVariationInquiryIntro: "Hello, I would like to send an inquiry for:",
    pdVariationInquiryQuoteLeadTime: "Please share the latest quotation and lead time.",
    pdVideoFallback: "Video failed to load. Please retry or open the source directly.",
    pdRetry: "Retry",
    pdOpenVideoUrl: "Open video URL",
    pdProductAttributes: "Product attributes",
    pdMediaTabsAria: "Product media types",
    pdMediaTabPhotos: "Photos",
    pdMediaTabVideo: "Video",
    pdMediaTabAttributes: "Attributes",
    pdInfoTabsAria: "Detail information tabs",
    pdInfoTabAttributes: "Attributes",
    pdInfoTabDescription: "Description",
    pdInfoTabSupplier: "Supplier",
    pdInfoTabReviews: "Reviews",
    pdKeyAttributes: "Key Attributes",
    pdPackagingShippingInfo: "Packaging and shipping information",
    pdProductDescription: "Product Description",
    pdSupplierOverview: "Supplier Overview",
    pdSupplierOverviewHint: "Company profile and FAQ are shown below detail images.",
    pdBuyerFeedback: "Buyer Feedback",
    pdRepeatBuyer: "Repeat buyer",
    pdReviewRatingAria: "Rating {rating} out of 5",
    pdReviewMetaColor: "color: {value}",
    pdReviewMetaColorFallback: "second",
    pdReviewUnavailable: "This product is no longer available",
    pdReviewHelpful: "Helpful ({count})",
    pdNoReviews: "No reviews yet for this product.",
    pdNoReviewsHint: "Contact our team for order references or sample feedback.",
    pdTitleFallback: "Product Detail",
    pdCustomizable: "Customizable",
    pdVariationCardAria: "Product variations",
    pdVariations: "Variations",
    pdSelectNow: "Select now",
    pdSelectOption: "Select option",
    pdLadderPricingAria: "Ladder pricing",
    pdProductSpecifications: "Product Specifications",
    pdSpecPrevAria: "Show previous specification value",
    pdSpecNextAria: "Show next specification value",
    pdSupplierCapability: "Supplier customization capability",
    pdGetFreeSample: "Get Free Sample",
    pdWhatsAppInquiry: "WhatsApp Inquiry",
    pdEmailInquiry: "Email Inquiry",
    pdPackagingDelivery: "Packaging & Delivery",
    pdProductVideo: "Product Video",
    pdVideoOpenLink: "Video cannot be played in the current context.",
    pdSupplierDescriptions: "Product descriptions from the supplier",
    pdCompanyIntroduction: "Company Introduction",
    pdNoCompanyIntroduction: "No company introduction configured.",
    pdFaq: "FAQ",
    pdNoFaq: "No FAQ configured.",
    pdCloseVariationSelector: "Close variation selector",
    pdVariationSelectAndQty: "Select variations and quantity",
    pdVariationStock: " / stock {count}",
    pdSelectedQuantity: "Selected quantity",
    pdSendInquiry: "Send inquiry",
    pdChatNow: "Chat now",
    pdOptionLabel: "Option {index}",
    pdRelatedAria: "Related products",
    pdRelatedTitle: "Related Products",
    pdRelatedSubtitle: "More items buyers often source together in this category.",
    pdRelatedPrevAria: "Previous related products",
    pdRelatedNextAria: "Next related products",
    pdSampleContactTitle: "Please contact us",
    pdSampleContactDesc: "Have questions? We're happy to help. Contact us on WhatsApp or email for sample support.",
    pdSampleCloseAria: "Close sample inquiry",
    pdSampleSummaryProduct: "Product",
    pdSampleSummaryQuantity: "Quantity",
    pdFormFullName: "Full name",
    pdFormFullNamePlaceholder: "Your name",
    pdFormEmail: "Email*",
    pdFormEmailPlaceholder: "Contact you via email",
    pdFormWhatsapp: "WhatsApp/WeChat*",
    pdFormWhatsappPlaceholder: "Contact you via WhatsApp",
    pdFormCompany: "Your company name",
    pdFormCompanyPlaceholder: "Your company name",
    pdFormRequiredQuantity: "Required Quantity",
    pdFormRequiredQuantityPlaceholder: "Required sample or trial quantity",
    pdFormMessage: "Message",
    pdFormMessagePlaceholder: "Please briefly describe your product requirements",
    pdFormSending: "Sending...",
    pdFormSendMessage: "Send Message",
    pdFormInquirySuccess: "Inquiry submitted successfully.",
    oemHeroKicker: "Custom Service",
    oemTitle: "Build a custom yoga line with a clear production workflow",
    oemIntro: "We support overseas buyers with product customization, packaging development, sample follow-up and order execution for yoga and light fitness categories.",
    oemStartProject: "Start Your Custom Project",
    oemBrowseProducts: "Browse Base Products",
    oemVisualGuide: "Customization Visual Guide",
    oemVisualAlt: "OEM customization options and process guide",
    oemVisualPlaceholder: "Customization image not found. Add your attachment to frontend/public/assets/about/oem-customization-guide.jpg",
    oemCapabilityKicker: "What We Can Customize",
    oemCapabilityTitle: "From logo application to full packaging execution",
    oemProjectBrief: "Project Brief",
    oemServiceShowcaseAria: "OEM and ODM customization services",
    oemServiceShowcaseTitle: "OEM & ODM Customization Services",
    oemServiceShowcaseBody: "Flexible one-stop support from concept review to production and shipment handoff.",
    oemCompareHeadBody: "Four common paths, shown as base product versus customized result.",
    oemCompareBaseSuffix: "base version",
    oemCompareOptionsSuffix: "customization options",
    oemCompareCustomizedSuffix: "customized version",
    oemCompare1Title: "Logo Application",
    oemCompare1Body: "Plain product to branded presentation.",
    oemCompare1BeforeLabel: "Base",
    oemCompare1AfterLabel: "With logo",
    oemCompare1CustomizationLabel: "Logo add-on",
    oemCompare1Item1: "Print",
    oemCompare1Item2: "Emboss",
    oemCompare1Item3: "Laser mark",
    oemCompare2Title: "Color and Finish",
    oemCompare2Body: "Neutral spec to market-fit colorway.",
    oemCompare2BeforeLabel: "Standard",
    oemCompare2AfterLabel: "Custom color",
    oemCompare2CustomizationLabel: "Color update",
    oemCompare2Item1: "Color",
    oemCompare2Item2: "Texture",
    oemCompare2Item3: "Size",
    oemCompare3Title: "Packaging Setup",
    oemCompare3Body: "Plain pack to retail-ready presentation.",
    oemCompare3BeforeLabel: "Plain pack",
    oemCompare3AfterLabel: "Retail-ready",
    oemCompare3CustomizationLabel: "Pack details",
    oemCompare3Item1: "Insert card",
    oemCompare3Item2: "Barcode",
    oemCompare3Item3: "Carton mark",
    oemCompare4Title: "Bundle Development",
    oemCompare4Body: "Single items to channel-ready set.",
    oemCompare4BeforeLabel: "Single items",
    oemCompare4AfterLabel: "Bundle set",
    oemCompare4CustomizationLabel: "Bundle logic",
    oemCompare4Item1: "Studio set",
    oemCompare4Item2: "Amazon pack",
    oemCompare4Item3: "Promo mix",
    oemCasesTitle: "Customization Cases",
    oemCase1Title: "Boutique Studio Starter Line",
    oemCase1Summary: "Starter kit presentation for boutique studio launch.",
    oemCase1Details: "Logo-ready bundle approved in 12 days.",
    oemCase2Title: "Retail Private Label Refresh",
    oemCase2Summary: "Updated packaging look for cleaner shelf presentation.",
    oemCase2Details: "Faster buyer sign-off and stronger retail consistency.",
    oemCase3Title: "Marketplace-Ready Fitness Bundle",
    oemCase3Summary: "Bundle setup prepared for e-commerce and listing use.",
    oemCase3Details: "Insert, barcode and bulk-production review ready.",
    oemOrderingFlowKicker: "Ordering Flow",
    oemOrderingFlowTitle: "Contact and order in five steps",
    oemContactFlow1: "Initial inquiry with product list, destination market and branding request.",
    oemContactFlow2: "Quotation with sample plan, lead time and packaging options.",
    oemContactFlow3: "Sample confirmation and order details approval.",
    oemContactFlow4: "Deposit, production, inspection and shipment booking.",
    oemContactFlow5: "Balance payment, export documents and after-sales follow-up.",
    oemContactSideTitle: "Ready to discuss your OEM request?",
    oemContactSideBody: "Send your logo, quantity target and packaging idea. We will reply with a practical quotation route and sample recommendation.",
    oemContactSideNote: "Preferred first contact: email or inquiry form with artwork and target shipment window.",
    oemContactSideCta: "Contact Sales Team",
    newsHeroKicker: "Industry Updates",
    newsTitle: "News & Updates",
    newsIntro: "Follow our latest sourcing insights, product launch notes, and export updates for fitness accessory buyers.",
    newsSectionTitle: "For custom project announcements or new collection previews, contact our sales team for the latest catalog.",
    contactTitle: "Contact Supplier",
    contactHeroKicker: "Business Inquiry",
    contactIntro: "Tell us your product requirements and target market. Our team will reply with quotation details and lead-time estimates.",
    contactFormTitle: "Send Inquiry",
    contactName: "Your Name",
    contactEmail: "Work Email",
    contactCompany: "Company Name",
    contactMessage: "Product specs, quantity, shipping destination",
    contactSubmit: "Send Inquiry",
    contactSent: "Message submitted successfully.",
    contactInfoTitle: "Sales Office",
    contactInfoEmail: "Email",
    contactInfoPhone: "Phone",
    contactInfoHours: "Working Hours: Mon-Sat, 09:00-18:00 (GMT+8)",
    contactInfoNote: "Preferred channels: Email for formal quotation, phone for urgent order schedule confirmation.",
    contactResponseTitle: "Average Response Time",
    contactResponseDesc: "Within 8 business hours for standard RFQ requests.",
    contactInquiryGreeting: "Hello, I would like to inquire about this product:",
    contactInquiryProductPrefix: "Product:",
    contactInquiryQuantity: "Quantity:",
    contactInquiryDestinationPort: "Destination Port:",
    aboutTitle: "About LOYA SPORT",
    aboutIntro: "LOYA SPORT is a yoga product supply chain integrator serving global B2B buyers.",
    aboutWhoWeAre: "Who We Are",
    aboutWhoWeAreDesc1: "We support importers, distributors, retailers and private-label brands by coordinating sourcing, sampling, branding and shipment follow-up with verified supply partners.",
    aboutWhoWeAreDesc2: "Our strength is practical communication, category focus and a clear buying workflow that helps overseas customers move faster.",
    aboutSupplyCapabilities: "Supply Capabilities",
    aboutSupplyList1: "Verified supplier coordination for yoga and light fitness lines",
    aboutSupplyList2: "Multi-stage quality review with partner factories",
    aboutSupplyList3: "Private label and packaging support",
    aboutSupplyList4: "Global supply support across major regions and channels",
    aboutMission: "Our Mission",
    aboutMissionDesc: "To help fitness brands and retail buyers grow through dependable sourcing, strict quality control, and complete after-sales support.",
    navHome: "Home",
    navProducts: "Products",
    navCustomization: "Custom Service",
    navSolutions: "Solutions",
    navAbout: "About",
    navContact: "Contact Us",
    btnContactUs: "Contact us",
    btnLogin: "Login",
    btnAccount: "Account",
    btnQuote: "Request Quote",
    btnCurrency: "Currency",
    btnLanguage: "Language",
    requestQuote: "Request Quote",
    requestFreeSample: "Request Free Sample",
    trustTitle: "Global Partners & Trust",
    factoryStatsSince: "Since 1995",
    factoryStatsSize: "30,000 sqm Factory",
    factoryStatsQC: "100% In-line & Final QC",
    factoryStatsExport: "Exporting to 50+ Countries",
    homeAriaTrust: "Trust and partners",
    homeAriaStats: "Factory stats and data",
    authLogin: {
        welcomeBack: "Welcome Back",
        brandIntro: "Sign in to continue sourcing yoga and fitness products.",
        brandBullet1: "Fast RFQ workflow",
        brandBullet2: "Product and order follow-up",
        brandBullet3: "B2B account support",
        accountLogin: "Account Login",
        createAccount: "Create Account",
        recoverPassword: "Recover Password",
        registrationComplete: "Registration Complete",
        passwordUpdated: "Password Updated",
        loginDesc: "Use your username or email and password to continue.",
        registerDesc: "Create your account with username, email verification, and captcha protection.",
        forgotDesc: "Enter your account email to receive a reset code and set a new password.",
        registerSuccessDesc: "Your account has been created successfully. We will switch back to the login view automatically.",
        resetSuccessDesc: "Your password has been updated successfully. We will switch back to the login view automatically.",
        redirectHintPrefix: "The page will switch to the login screen in",
        redirectHintSuffix: ".",
        seconds: "seconds",
        loginNow: "Log In Now",
        username: "Username",
        usernamePlaceholder: "At least 3 characters, for example loya_buyer",
        usernameHelp: "Username must be at least 3 characters, must not use reserved words, and may only contain letters, numbers, underscores, and hyphens.",
        usernameExistsHint: "This username is already registered. Try logging in directly or choose another username.",
        usernameExists: "Username already exists. Please choose another username or log in directly.",
        usernameExistsAction: "Username exists, go to login",
        usernameAlreadyRegistered: "This username is already registered.",
        usernameAvailable: "Username is available.",
        usernameVerifyFailed: "Unable to verify username right now. Please try again.",
        checkingUsername: "Checking username availability...",
        email: "Email",
        emailPlaceholder: "your@email.com",
        emailCodeTargetHint: "Enter the email address you want to use to receive the verification code.",
        emailExistsHint: "This email is already registered. Try logging in directly or use another email.",
        emailExists: "Email already exists. Please use another email or go to login.",
        emailExistsAction: "Email exists, go to login",
        emailAlreadyRegistered: "This email is already registered.",
        emailAvailable: "Email is available.",
        emailVerifyFailed: "Unable to verify email right now. Please try again.",
        checkingEmail: "Checking email availability...",
        usernameOrEmail: "Username or Email",
        usernameOrEmailPlaceholder: "username or your@email.com",
        forgotEmailHint: "Enter the email address linked to your account so we can send a reset code.",
        password: "Password",
        passwordPlaceholder: "Enter password",
        confirmPassword: "Confirm Password",
        confirmPasswordPlaceholder: "Re-enter password",
        confirmNewPassword: "Confirm New Password",
        confirmNewPasswordPlaceholder: "Re-enter the new password",
        nickname: "Nickname",
        nicknamePlaceholder: "Optional, used for display",
        captcha: "Captcha",
        registerCaptcha: "Registration captcha",
        resetCaptcha: "Reset captcha",
        refreshCaptcha: "Refresh captcha",
        load: "Load",
        forgotCaptchaHint: "Complete the captcha first, then request the password reset code. After the code is sent, a new captcha will be loaded automatically for the final reset step.",
        registerCaptchaHint: "Complete the captcha first, then request the email verification code.",
        registerStepHint: "Fill in username, password, confirm password, and a valid email first. Then the captcha and email-code section will appear.",
        emailCode: "Email Code",
        emailCodePlaceholder: "6-digit code",
        resetCode: "Reset Code",
        resetCodePlaceholder: "6-digit reset code",
        sending: "Sending...",
        resendIn: "Resend in",
        sendEmailCode: "Send Email Code",
        sendResetCode: "Send Reset Code",
        signingIn: "Signing in...",
        login: "Login",
        updating: "Updating...",
        creating: "Creating...",
        resetPassword: "Reset Password",
        forgotRequirementHint: "Password recovery requires both captcha verification and the reset code sent to your email.",
        registerRequirementHint: "Registration requires the email code sent to your inbox.",
        captchaRefreshHint: "If the captcha is hard to read, click the image on the right to refresh it.",
        switchToLogin: "Already have an account? Log in now",
        switchToRegister: "No account yet? Register now",
        backToLogin: "Back to login",
        forgotPassword: "Forgot password?",
        usernameRequired: "Enter a username with at least 3 characters.",
        usernameMin: "Username must be at least 3 characters.",
        usernameMax: "Username must be 24 characters or fewer.",
        usernamePattern: "Username may only contain letters, numbers, underscores, and hyphens.",
        usernameReserved: "This username is reserved. Please choose another one.",
        usernameFormatOk: "Username format looks good.",
        emailRequired: "Enter an email address.",
        emailInvalid: "Enter a valid email address.",
        emailFormatOk: "Email format looks good.",
        emailProviderHint: "Use a common email provider when possible, such as Gmail, Outlook, QQ Mail, 163, 126, or Foxmail.",
        passwordRequired: "Enter a password.",
        didYouMean: "Did you mean",
        passwordMin: "Password must be at least 6 characters.",
        newPasswordMin: "New password must be at least 6 characters.",
        confirmPasswordRequired: "Enter the confirmation password.",
        passwordMatch: "Passwords match.",
        passwordMismatch: "The two passwords do not match.",
        emailCodeRequired: "Enter the email verification code.",
        resetCodeRequired: "Enter the reset code sent to your email.",
        captchaRequired: "Enter the captcha code.",
        captchaExpired: "The captcha has expired. Please refresh it and try again.",
        captchaIncorrect: "The captcha code is incorrect. Please try again.",
        registerPrerequisitesError: "Complete username, password, confirm password, and a valid email before requesting the email verification code.",
        enterCaptchaBeforeEmailCode: "Enter the captcha code before requesting the email verification code.",
        enterCaptchaBeforeResetCode: "Enter the captcha code before requesting the password reset code.",
        sendEmailCodeFailed: "Failed to send the email verification code.",
        emailCodeSent: "The email verification code has been sent.",
        emailCodeSentInbox: "The email verification code has been sent. Please check your inbox.",
        previewCodeCurrentEnv: "Preview code for the current environment",
        previewCodeDevelopment: "Preview code for development",
        previewCodeGenerated: "The email verification code has been generated. This environment is using a preview code.",
        previewCodeContinueRegistration: "Enter this 6-digit code to continue registration.",
        tooManyRequests: "Too many requests. Please try again later.",
        smtpConfigRetry: "Failed to send the email. Check the SMTP configuration and try again.",
        emailServiceNotConfigured: "The email delivery service is not configured. Please contact the administrator.",
        requestFailed: "Request failed. Please try again or contact support.",
        registerFailed: "Register failed",
        resetFailed: "Password reset failed",
        loginFailed: "Login failed",
        accountNotFound: "Account not found. Check your username or email.",
        passwordIncorrect: "Incorrect password. Please try again.",
        registrationNotOpen: "Login and registration are currently closed.",
        accountRestricted: "This account has been restricted from logging in. Please contact an administrator.",
        registerSuccessNotice: "Registration successful. Redirecting to the login screen in about 4 seconds.",
        resetSuccessNotice: "Password reset successful. Redirecting to the login screen in about 1.5 seconds.",
        loginTokenMissing: "Login token missing",
        profileLoadFailed: "Failed to load account profile",
        loginSuccessAdmin: "Login successful. Redirecting...",
        loginSuccessStorefront: "Login successful. Redirecting to the storefront...",
        loginServiceUnavailable: "Login service is temporarily unavailable. Please try again in a moment.",
        orContinueWith: "Or continue with",
        googleAuthorizing: "Authorizing Google account...",
        googleFallbackAction: "Continue with Google",
        googleAuthFailed: "Google authentication failed",
        googleAuthOffline: "Google sign-in is temporarily unavailable offline. Please connect to the internet or use username/password.",
        googleAuthTimeout: "Google verification timed out. Please retry shortly. If it keeps failing, ask the administrator to check backend outbound network access.",
        googleAuthNetworkError: "Google verification failed due to backend network error. Please contact administrator.",
        googleRegisterSuccess: "Google account linked successfully. Redirecting to the storefront...",
        googleCreateAccountTitle: "Complete Your Google Signup",
        googleCreateAccountDesc: "Google verified your email. Set a password to create a customer account and finish sign-in.",
        googleCreateAccountHint: "No account exists for this Google email yet. Set a password to create your customer account.",
        googleLinkedEmailHint: "This verified Google email will be used to create your customer account.",
        googleCreatePasswordHint: "Set and confirm a password. The new customer account will use your Google-verified email."
    },
    admin: {
        productCategoryYogaMats: "Yoga Mats",
        productCategoryYogaBlocks: "Yoga Blocks",
        productCategoryYogaStraps: "Yoga Straps",
        productCategoryResistanceBands: "Resistance Bands",
        productCategoryPilatesRings: "Pilates Rings",
        productCategoryFoamRollers: "Foam Rollers",
        productCategoryOthers: "Others",
        faqSampleOrderQ: "Do you accept sample order?",
        faqSampleOrderA: "Yes, we accept sample order, pls feel free to contact us.",
        faqCustomPackagingQ: "Do you offer customized packaging and logo service?",
        faqCustomPackagingA: "Yes, we offer customized OEM/ODM service.",
        faqLeadTimeQ: "What is your lead time?",
        faqLeadTimeA: "Usually 1-3 days depends on order qty, final lead time to be confirmed when order is placed.",
        faqDefectiveItemQ: "How to deal with the defective item?",
        faqDefectiveItemA: "We offer ONE YEAR warranty starting from the date of shipment, during the warranty, If you have a defective item due to our material and workmanship, pls provide us with details including the description, photo or video,and even defective sample when needed, our engineers will analyse and give you solution. If you want to return, please contact us and return the items with its original packaging and accessories, money will be refunded when the returned items are received or free replacement will be sent.",
        faqWhyChooseUsQ: "Why choose us ?",
        faqWhyChooseUsA: "Our products are with low MOQ , high quality that can meet US or EU standard . We provide high level service , accept OEM and Trade assurance order. You can ship without worries.",
        companyImageSectionOverview: "Company overview",
        companyImageSectionAdvantages: "Competitive advantages",
        companyImageSectionCustomization: "Customization capabilities",
        companyImageSectionExtended: "Extended company profile",
        companyImageSectionPackaging: "Packaging & shipping specifications",
        companyImageSectionFactory: "Factory profile",
        companyImageSectionWorkflow: "Production workflow",
        companyImageSectionTradeShow: "Trade show participation",
        orderStatusPaid: "Paid",
        orderStatusPacked: "Packed",
        orderStatusInTransit: "In Transit",
        orderStatusDelivered: "Delivered",
        orderStatusCancelled: "Cancelled",
        tabDescHome: "Manage your workspace operations and monitor performance here.",
        tabDescStoreBase: "Configure storefront/admin titles and SEO metadata.",
        tabDescTemplateStudio: "Visually edit storefront layout modules and save custom templates.",
        tabDescArticleManagement: "Manage blog articles in a dedicated workspace with dialog-based editing.",
        tabDescCompanyImages: "Manage company image categories used in shop profile content.",
        tabDescDesignNav: "Configure storefront navigation and nested menu structures.",
        tabDescDesignCarousel: "Manage storefront homepage carousel banners.",
        tabDescDesignBanner: "Configure banner messages and call-to-action content.",
        tabDescFaqKnowledge: "Maintain a knowledge base of FAQs used by operations and sales teams.",
        tabDescProducts: "Manage product catalog, details, and pricing information.",
        tabDescProductCreate: "Create new products and complete all information and media.",
        tabDescMerchandising: "Evaluate candidate products, pricing structures and launch readiness.",
        tabDescProcurement: "Coordinate procurement plans, supplier progress and purchase priority.",
        tabDescQuality: "Track quality inspection checkpoints and release readiness before fulfillment.",
        tabDescLogistics: "Follow up on shipment status, packaging preparation and logistics coordination.",
        tabDescOrders: "Track the full order lifecycle, fulfillment and shipping updates.",
        tabDescCustomers: "Manage team members and their account permissions here.",
        tabDescMarketing: "View marketing campaign status and growth performance.",
        tabDescDiscounts: "Manage pricing strategies and promotion rules.",
        tabDescFinance: "Monitor financial records and revenue trends.",
        tabDescFinanceIncome: "Review order collections, recognized revenue, and income ledger records.",
        tabDescFinanceExpenses: "Track purchasing, logistics, marketing, and office expense bills.",
        tabDescFinanceReceivables: "Track receivables, aging, and collection priorities.",
        tabDescFinancePayables: "Manage payables, supplier payments, and due-date pressure.",
        tabDescFinanceInvoices: "Maintain invoices, receipts, and billing status.",
        tabDescFinanceTax: "Review output tax, input tax, and tax estimates.",
        tabDescFinanceBudget: "Track budgets, expense allocation, and overspend alerts.",
        tabDescFinanceDaily: "Summarize company income, expenses, and net cash by day.",
        tabDescFinanceMonthly: "Close monthly books and review profit plus budget variance.",
        tabDescFinanceYearly: "Review annual revenue, expenses, tax, and net profit.",
        tabDescFinanceReconciliation: "Reconcile receivables, collections, payables, invoices, and tax state.",
        tabDescFinanceApprovals: "Handle refund, payment, and expense approval audits.",
        tabDescFinanceReports: "Summarize finance statements, operating metrics, and export jobs.",
        tabDescAnalytics: "Analyze data insights and operational metrics.",
        tabDescSettings: "Manage underlying system settings like database connections.",
        tabDescWorkTargets: "Track and coordinate daily task objectives.",
        tabDescWorkProcessing: "Process assigned workflows and execution records.",
        tabDescHrEmployee: "View and maintain employee profiles and account info.",
        tabDescHrRecruitment: "Track onboarding and recruitment-related task queues.",
        tabDescHrAttendance: "Monitor employee attendance and account activity status.",
        tabDescHrOffice: "Manage position coverage and internal administrative tasks.",
        tabDescSiteMaintenance: "Maintain storefront content and site stability.",
        tabDescPermissionMaintenance: "Maintain role-based permissions and access boundaries.",
        tabDescPositionMaintenance: "Maintain position structures and user mappings.",
        tabDescProfile: "View your account information.",
        tabDescPassword: "Change your account password securely.",
        tabDescInquiry: "Contact sellers and continue inquiry discussions.",
        tabDescWishlist: "Manage bookmarked products and preferred selections.",
        tabDescOrderProcessing: "Track and process full lifecycle order records.",
        tabDescAfterSales: "Follow up on after-sales requests and support tickets.",
        roleDeveloper: "Developer",
        roleSuperAdmin: "Super Admin",
        roleAdmin: "Admin",
        roleCustomer: "Customer",
        roleGuest: "Guest",
        productCreateMenu: "Publish Product",
        productsMenu: "Product List",
        merchandisingOverview: "Merchandising Overview",
        merchandisingCollection: "Collection Pool",
        internalOverview: "Overview & Config",
        internalWorkspace: "Product & Fulfillment",
        internalBusiness: "Sales & Customers",
        internalOffice: "Position Tasks",
        internalMaintenance: "Maintenance Panel",
        storefrontContent: "Storefront Content",
        guestService: "Guest Services",
        customerService: "Customer Services",
        commonAccount: "My Account",
        siteMaintenanceMenu: "Position Management",
        positionMaintenanceMenu: "User Management",
        title: "My Store",
        home: "Operations Overview",
        storeDesign: "Store Setup",
        companyProfile: "Company Profile",
        storeBase: "Store Base Params",
        templateStudio: "Template Studio",
        articleManagement: "Article Management",
        companyProfileMenu: "Company Profile",
        companyImages: "Company Images",
        designNav: "Navigation Menus",
        designCarousel: "Homepage Carousel",
        designBanner: "Banner Settings",
        faqKnowledge: "FAQ Knowledge Base",
        products: "Product Management",
        productCreate: "Add Product Details",
        merchandising: "Merchandising Center",
        procurement: "Procurement Center",
        quality: "Quality Center",
        logistics: "Logistics Sync",
        orders: "Inquiry & Orders",
        customers: "Customer Management",
        marketing: "Marketing Campaigns",
        discounts: "Pricing Strategies",
        finance: "Finance Overview",
        financeIncome: "Income Ledger",
        financeExpenses: "Expense Bills",
        financeReceivables: "Receivables",
        financePayables: "Payables",
        financeInvoices: "Invoice Management",
        financeTax: "Tax Management",
        financeBudget: "Budget & Expenses",
        financeDaily: "Daily Bills",
        financeMonthly: "Monthly Closing",
        financeYearly: "Annual Statements",
        financeReconciliation: "Reconciliation",
        financeApprovals: "Approvals & Audit",
        financeReports: "Reports & Export",
        analytics: "Data Analytics",
        settings: "System Settings",
        menuCommon: "Common",
        menuInternal: "Internal",
        menuWorkContent: "Work Content",
        menuMaintenance: "Maintenance Panel",
        userManagementGroup: "Maintenance Panel",
        menuGuest: "Guest",
        menuCustomer: "Customer",
        workTargets: "Task Objectives",
        workProcessing: "Work Processing",
        hrEmployee: "Employee Records",
        hrRecruitment: "Recruitment Management",
        hrAttendance: "Attendance Management",
        hrOffice: "Administrative Tasks",
        siteMaintenance: "Position Maintenance",
        permissionMaintenance: "Permission Maintenance",
        positionMaintenance: "User Management",
        profile: "Personal Info",
        password: "Change Password",
        inquiry: "Inquiry Chat",
        wishlist: "Wishlist",
        orderProcessing: "Order Processing",
        afterSales: "After-Sales Service",
        profileCardTitle: "Account Profile",
        accountId: "Account ID",
        profileName: "Name",
        profileEmail: "Email",
        profileRole: "Role",
        passwordCardTitle: "Change Account Password",
        currentPassword: "Current Password",
        adminResetPasswordHint: "This is for administrators to reset passwords for target users. You do not need the target user's current password.",
        newPassword: "New Password",
        confirmPassword: "Confirm New Password",
        savePassword: "Update Password",
        passwordUpdated: "Password updated successfully.",
        inquiryCardTitle: "Inquiry Center",
        inquiryCardBody: "Contact the seller team to discuss product needs, pricing, and delivery schedules.",
        openInquiryCenter: "Open Inquiry Page",
        openWhatsappChat: "WhatsApp Chat",
        permissionSectionTitle: "Current Permissions",
        permissionSectionBody: "Permissions are parsed from the login response and position structure.",
        placeholderTodo: "This module is open for the current position. You can extend specific business operations here.",
        systemConfigTitle: "System Configuration Center",
        settingsTabDatabase: "Database",
        settingsTabDatabaseHint: "Connection and pool configuration",
        settingsTabEmail: "Email",
        settingsTabEmailHint: "Branding and transactional templates",
        mysqlHost: "MySQL Host",
        mysqlPort: "MySQL Port",
        mysqlDatabase: "MySQL Database Name",
        mysqlUser: "MySQL Username",
        mysqlPassword: "MySQL Password",
        mysqlPoolSize: "MySQL Pool Size",
        mysqlConnectTimeoutMs: "MySQL Timeout (ms)",
        saveSystemConfig: "Save System Settings",
        systemConfigSavedToast: "System configuration saved",
        systemConfigPathLabel: "Config File",
        restartRequiredHint: "A restart of the backend service is required for new database settings to take effect.",
        storefrontTitle: "Storefront Title",
        adminTitle: "Admin Panel Title",
        seoMetaTitle: "SEO Title",
        seoDescription: "SEO Description",
        seoKeywords: "SEO Keywords",
        seoCanonicalUrl: "Canonical URL",
        seoRobots: "SEO Robots",
        seoOgTitle: "Open Graph Title",
        seoOgDescription: "Open Graph Description",
        seoOgImage: "Open Graph Image URL",
        seoTwitterCard: "Twitter Card Type",
        seoTwitterSite: "Twitter Site Handle",
        saveBaseSettings: "Save Base Settings",
        baseSavedToast: "Base settings saved",
        hello: "Hello, let's get started.",
        askAnything: "Ask anything...",
        supportLine: "Have questions? Contact support",
        addStoreName: "Add Store Name",
        firstProduct: "Add Your First Product",
        firstProductDesc: "Start by adding a product and providing key details.",
        addProduct: "Add Product",
        importData: "Import",
        customizeStore: "Customize Your Store",
        customizeStoreDesc: "Pick a template, add your logo, colors, and images.",
        customTemplate: "Custom Template",
        payments: "Set Up Commerce Payments",
        shipping: "Check Your Shipping Rates",
        domain: "Custom Domain",
        quickSales: "Simplify Market Sales",
        quickSalesDesc: "Sync sales and management across multiple platforms.",
        storeSettings: "Store Settings",
        general: "General",
        billing: "Billing",
        usersPermissions: "Users",
        paginationPrevious: "Previous",
        paginationNext: "Next",
        paginationPage: "Page",
        paginationTotal: "of",
        policies: "Policies",
        businessInfo: "Business Details",
        contactInfo: "Store Contact",
        defaults: "Store Defaults",
        businessMode: "Business Mode",
        b2b: "B2B",
        b2c: "B2C",
        modeSaved: "Store mode updated",
        modeSavedToast: "Business mode switched successfully",
        navSettings: "Navigation Menu",
        navLabel: "Submenu Label",
        navPath: "Submenu Link",
        addSubmenu: "Add Submenu",
        saveNavigation: "Save Submenus",
        navSavedToast: "Navigation menu saved",
        bannerSettings: "Banner List",
        bannerTitle: "Banner Title",
        bannerAnnotation: "Image Annotation",
        bannerButtonText: "Button Text",
        bannerButtonLink: "Button Link",
        bannerImageUrl: "Banner Image URL",
        addBanner: "Add Banner",
        removeBanner: "Remove",
        saveBanners: "Save Banners",
        bannersSavedToast: "Banner list saved",
        saveFaqKnowledge: "Save FAQs",
        faqKnowledgeSavedToast: "FAQ knowledge base saved",
        saveCompanyImages: "Save Company Images",
        companyImagesSavedToast: "Company image config saved",
        companyIntroductionTitle: "Company Intro",
        companyIntroductionHint: "Used to showcase profile, advantages, and service capacity.",
        companyIntroductionPlaceholder: "Enter company intro content...",
        addImageUrl: "Add Image URL",
        uploadLocalImages: "Upload Local Images",
        addFaq: "Add FAQ",
        saveCarouselImages: "Save Carousel Images",
        carouselImagesSavedToast: "Carousel images saved",
        close: "Close",
        save: "Save",
        create: "Create",
        search: "Search Current View",
        refresh: "Refresh",
        createProduct: "Add Product",
        cancel: "Cancel",
        edit: "Edit",
        remove: "Delete",
        systemSnapshot: "System Snapshot",
        activeSearch: "Active Search",
        none: "(None)",
        orderRecords: "Order Records",
        userRecords: "User Records",
        lastRefresh: "Last Refreshed",
        productsCount: "Products",
        customersCount: "Customers",
        ordersCount: "Orders",
        revenue: "Revenue USD",
        localeLabel: "Locale",
        sku: "SKU",
        name: "Name",
        description: "Description",
        price: "Price USD",
        imageUrl: "Image URL",
        category: "Category",
        model: "Model",
        titleField: "Product Title",
        detailVideo: "Detail Video URL",
        mainImages: "Main Images (6 links, one per line)",
        detailImages: "Detail Images (one per line)",
        parameters: "Parameters (key:value per line)",
        openCreateProduct: "Open Product Form",
        id: "ID",
        serialNumber: "#",
        userId: "User",
        actions: "Actions",
        email: "Email",
        role: "Role",
        username: "Username",
        nickname: "Nickname",
        userRole: "User Role",
        phone: "Phone",
        accountStatus: "Account Status",
        jobTitle: "Job Title",
        registeredAt: "Registered At",
        lastActiveAt: "Last Active",
        statusActive: "Active",
        statusDisactive: "Inactive",
        permissions: "Permissions",
        position: "Position",
        accessSummary: "Access",
        positionName: "Position Name",
        positionKey: "Position Key",
        department: "Department",
        addPosition: "Add Position",
        permissionName: "Permission Name",
        permissionKey: "Permission Key",
        addPermission: "Add Permission",
        editPermissions: "Edit Permissions",
        permissionSelectTitle: "Select Permissions",
        permissionSelectedSummary: "Selected",
        permissionQuickSearchPlaceholder: "Quick search by key or comment",
        defaultAdminPosition: "Operations Admin",
        orderId: "Order ID",
        total: "Total",
        status: "Status",
        cartItems: "Cart Items",
        logout: "Log Out",
        changePasswordAction: "Change Password",
        userPasswordModalTitle: "Modify User Password",
        userPasswordUpdated: "User password updated successfully.",
        targetUser: "Target User",
        userDataResyncedHint: "Detected field override from server after save. Synced latest data.",
        userManagementRestrictedHint: "This operation requires higher privileges.",
        capability: {
            "admin:overview:read": "Read Admin Overview",
            "admin:products:read": "Read Admin Products",
            "admin:products:write": "Write Admin Products",
            "admin:orders:read": "Read Admin Orders",
            "admin:orders:write": "Write Admin Orders",
            "admin:users:read": "Read Admin Users",
            "admin:users:role:write": "Write User Roles",
            "admin:users:position:assign": "Assign User Positions",
            "admin:storefront:read": "Read Storefront Settings",
            "admin:storefront:write": "Write Storefront Settings",
            "admin:system-config:read": "Read System Config",
            "admin:system-config:write": "Write System Config",
            "shop:profile:read": "Read Shop Profile",
            "shop:password:write": "Write Shop Password",
            "shop:orders:read": "Read Shop Orders",
            "shop:inquiry:write": "Handle Shop Inquiry",
            "shop:wishlist:read": "Read Wishlist",
            "shop:orders:processing:read": "Read Order Processing",
            "shop:after-sales:read": "Read After-Sales",
            "internal:work:targets:read": "Read Work Targets",
            "internal:work:processing:read": "Read Work Processing",
            "internal:maintenance:site:write": "Write Site Maintenance",
            "internal:maintenance:permission:write": "Write Permission Maintenance",
            "internal:maintenance:position:write": "Write Position Maintenance",
            "shop:products:read": "Read Shop Products",
            "shop:storefront:read": "Read Shop Storefront",
            "internal:system:config:read": "Read Internal System Config",
            "internal:system:config:write": "Write Internal System Config",
            "internal:security:audit:read": "Read Security Audit",
            "internal:security:session:revoke": "Revoke Session",
            "internal:integration:manage": "Manage Integrations",
            "admin:users:write": "Write Admin Users",
            "admin:users:password:reset": "Reset User Password",
            "admin:users:delete": "Delete Admin User",
            "crm:customer:read": "Read Customer Profile",
            "crm:customer:write": "Write Customer Profile",
            "crm:customer:assign": "Assign Customer Ownership",
            "website:content:read": "Read Website Content",
            "website:content:write": "Write Website Content",
            "website:navigation:write": "Write Website Nav",
            "website:banner:write": "Write Website Banners",
            "website:seo:write": "Write Website SEO",
            "website:theme:write": "Write Website Theme",
            "website:publish": "Publish Website Content",
            "admin:products:create": "Create Admin Products",
            "admin:products:delete": "Delete Admin Products",
            "merchandising:selection:read": "Read Selection Pool",
            "merchandising:selection:write": "Write Selection Pool",
            "catalog:pricing:write": "Write Catalog Pricing",
            "catalog:inventory:write": "Write Catalog Inventory",
            "catalog:translation:write": "Write Catalog Translation",
            "sales:inquiry:read": "Read Sales Inquiry",
            "sales:inquiry:reply": "Reply Sales Inquiry",
            "sales:quotation:create": "Create Sales Quote",
            "sales:quotation:approve": "Approve Sales Quote",
            "sales:contract:write": "Write Sales Contract",
            "sales:sample:manage": "Manage Sample Workflow",
            "order:status:update": "Update Order Status",
            "order:split:merge": "Split or Merge Orders",
            "procurement:purchase:write": "Write Purchase Orders",
            "production:plan:write": "Write Production Plans",
            "qa:inspection:write": "Write QA Inspections",
            "logistics:shipment:write": "Write Shipment Info",
            "logistics:tracking:read": "Read Logistics Tracking",
            "trade:customs:doc:write": "Write Customs Docs",
            "finance:invoice:read": "Read Invoices",
            "finance:invoice:write": "Write Invoices",
            "finance:payment:read": "Read Payments",
            "finance:payment:write": "Write Payments",
            "finance:refund:approve": "Approve Refund",
            "finance:reconciliation:write": "Write Finance Recon",
            "finance:tax:write": "Write Tax Info",
            "marketing:campaign:read": "Read Marketing Campaigns",
            "marketing:campaign:write": "Write Marketing Campaigns",
            "marketing:coupon:write": "Write Coupons",
            "marketing:lead:export": "Export Sales Leads",
            "analytics:dashboard:read": "Read Analytics Dashboard",
            "analytics:report:export": "Export Analytics Reports",
            "support:ticket:read": "Read Support Tickets",
            "support:ticket:write": "Write Support Tickets",
            "support:return:approve": "Approve Return Request",
            "support:complaint:handle": "Handle Customer Complaints",
            "office:announcement:write": "Write Office Announcements",
            "office:document:read": "Read Office Documents",
            "office:document:write": "Write Office Documents",
            "office:workflow:approve": "Approve Office Workflow",
            "office:meeting:manage": "Manage Meeting Schedule",
            "hr:employee:read": "Read Employee Records",
            "hr:employee:write": "Write Employee Records"
        }
    },
};
